export const brandsListKey = () => ["brands-list"];

export const brandsListParamsKey = ({ queryParams }) => [...brandsListKey(), queryParams];
